import { generateURL } from 'gw-portals-url-js';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved

function generateDownloadURL(serviceEndpoint, token, sessionUUID) {
  const params = {
    token,
    sessionUUID
  };
  return generateURL("".concat(serviceEndpoint, "/download"), params);
}
export default class DocumentDownloadService {
  static getDocumentLink(serviceEndpoint, token, sessionUUID) {
    const link = generateDownloadURL(serviceEndpoint, token, sessionUUID);
    return link;
  }
  static getDocument(downloadEndpointURL, authHeader) {
    let errorCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _.noop;
    const params = {
      method: 'GET',
      url: downloadEndpointURL,
      headers: {
        'Content-Type': 'application/json'
      },
      responseType: 'arraybuffer'
    };
    return fetch(downloadEndpointURL, params).then(response => {
      if (response.ok) {
        response.blob().then(blob => {
          const filename = response.headers.get('Content-Disposition').replace('attachment; filename=', '');
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename);
          } else {
            const downloadLink = document.createElement('a');
            downloadLink.setAttribute('href', window.URL.createObjectURL(blob));
            downloadLink.setAttribute('download', filename);
            downloadLink.style.display = 'none';
            document.body.appendChild(downloadLink);
            downloadLink.click();
            downloadLink.remove();
          }
        });
      } else {
        errorCallback();
      }
    }).catch(() => {
      errorCallback();
    });
  }
}